export const CREATE_DEPARTMENT = 'common@create-department';
export const CREATE_AND_UPDATE_DEPARTMENT = 'common@create-and-update-department';
export const DELETE_DEPARTMENT = 'common@delete-department';
export const UPDATE_DEPARTMENT = 'common@update-department';

